export const TANK = "Tank";
export const HEALER = "Healer";
export const DPS = "DPS";
export const GATHERER = "Gatherer";
export const CRAFTER = "Crafter";
